import React, { useContext, useEffect, useState } from 'react';
import { Box, Chip } from '@mui/material';
import { AppContext } from '../../../AppContext';
import { Actions } from '../../../enums/ActionEnums';
import { ICountry } from '../../../generated/graphql';
import ContentGrid from './ContentGrid';
import SearchInput from './SearchInput';
import './index.css';

interface IProps {
  countries: ICountry[];
}

const CountryStep: React.FunctionComponent<IProps> = ({ countries }: IProps) => {
  const { dispatch, state } = useContext(AppContext);
  const [selectedCountryIds, setSelectedCountryIds] = useState<string[]>(
    state.selectedRecipientList?.countryIds || []
  );
  const [currentCountries, setCurrentCountries] = useState(countries);

  useEffect(() => {
    setCurrentCountries(countries);
  }, [countries]);

  const handleCheckClickedCountries = (typeId: string) => {
    let countryIds = [];
    if (selectedCountryIds.includes(typeId)) {
      countryIds = selectedCountryIds.filter((id) => id !== typeId);
      setSelectedCountryIds(countryIds);
    } else {
      countryIds = [typeId, ...selectedCountryIds];
      setSelectedCountryIds(countryIds);
    }
    dispatch({
      type: Actions.SetRecipientListCountries,
      payload: { countryIds }
    });
  };

  const filterValues = (text: string) => {
    const filtered = countries.filter((c) => c.name.toLowerCase().includes(text.toLowerCase()));
    setCurrentCountries(filtered);
  };

  return (
    <Box className="step-container">
      <Box className="section-header" sx={{ height: '80px', justifyContent: 'space-between' }}>
        <SearchInput id={'country-step-search-input'} filter={filterValues} sx={{ width: '40%' }} />
        {selectedCountryIds.length > 0 ? (
          <Chip
            id={'selected-countries-count'}
            data-testid={'selected-countries-count'}
            size="small"
            className="header-chip"
            label={`${selectedCountryIds.length} ${
              selectedCountryIds.length === 1 ? 'country' : 'countries'
            } selected`}
            onDelete={() => {
              setSelectedCountryIds([]);
              dispatch({
                type: Actions.SetRecipientListCountries,
                payload: { countryIds: [] }
              });
            }}
          />
        ) : (
          <span className="section-header-info-text">{countries.length} countries</span>
        )}
      </Box>
      <Box className="step-content-container">
        <ContentGrid
          data={currentCountries}
          clickedValues={selectedCountryIds}
          handleCheckClicked={handleCheckClickedCountries}
          editable={true}
          staticGrid
        />
      </Box>
    </Box>
  );
};

export default CountryStep;
